import { Form, Button, Input, Switch, Row, Col, Empty } from 'antd';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';

import { companyActions } from '../../../../redux/company/actions';

import { required } from '../../../../constants/validation';
import { useSelector } from 'react-redux';
import { getUserRoles } from '../../../../redux/auth/selectors';

import { useCompanyData } from './useCompanyData';

import { CompanyEditActionButtons } from './style';
import { Typography } from 'antd';
const { Text } = Typography;

export const CompanyEdit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { companyData, loading, saving } = useCompanyData();
  const { TextArea } = Input;

  useLayoutEffect(() => {
    form.setFieldsValue(companyData);
    return () => form.resetFields();
  }, [form, companyData]);

  const submitFinish = values => {
    dispatch(companyActions.updateCompany(companyData._id, values));
  };

  const userRoles = useSelector(getUserRoles);

  const canUserEdit = (isSupervisorField = false) => {
    if (userRoles.indexOf('admin') != -1) {
      return false;
    }

    if (userRoles.indexOf('super_user') != -1) {
      return true;
    }
    return isSupervisorField;
  };

  return (
    <>
      {/* <AnalyticsSettings /> */}
      <PageHeader titleTranslationKey='companies.editCompanyTitle' onBack={() => navigate('/front/companies')} />
      <Loader loading={loading}>
        {companyData ? (
          <Form name='MyCompanyAdd' form={form} layout='vertical' scrollToFirstError={true} onFinish={submitFinish}>
            <Row>
              <Col span={11}>
                <Form.Item
                  name='wcoxmlweb_enabled'
                  label={t('myCompanies.wcoxmlweb_enabled')}
                  valuePropName='checked'
                  {...required}
                >
                  <Switch checked={companyData.wcoxmlweb_enabled} disabled={canUserEdit()} />
                </Form.Item>
                {companyData.wcoxmlweb_enabled ? (
                  <Text type='danger'>Wyłączenie możliwe tylko po wyłączeniu przetwarzania wcoxmlweb</Text>
                ) : (
                  <></>
                )}
                <Form.Item name='is_enabled' label={t('myCompanies.lisining')} valuePropName='checked' {...required}>
                  <Switch checked={companyData.is_enabled} disabled={canUserEdit() || companyData.wcoxmlweb_enabled} />
                </Form.Item>
                <Form.Item name='name' label={t('myCompanies.name')} {...required}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='tax_id' label={t('myCompanies.tax_id')} {...required}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='alerts_email' label={t('myCompanies.alertEmails')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='dhl_ids' label={t('myCompanies.dklNumbers')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
              </Col>
              <Col span={11} push={1}>
                <Form.Item name='address' label={t('myCompanies.address')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='floor_name' label={t('myCompanies.floor_name')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='city' label={t('myCompanies.city')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='postal_code' label={t('myCompanies.postal_code')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
                <Form.Item name='country' label={t('myCompanies.country')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={11}>
                <Form.Item name='trader_name' label={t('myCompanies.trader')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
              </Col>
              <Col span={12} push={1}>
                <Form.Item name='trader_email' label={t('myCompanies.email')}>
                  <Input autoComplete='off' disabled={canUserEdit()} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={11}>
                <Form.Item name='supervisor_name' label={t('myCompanies.supervisor')}>
                  <Input autoComplete='off' disabled={canUserEdit(true)} />
                </Form.Item>
              </Col>
              <Col span={12} push={1}>
                <Form.Item name='supervisor_email' label={t('myCompanies.email')}>
                  <Input autoComplete='off' disabled={canUserEdit(true)} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={22} push={1}>
                <Form.Item name='trader_notes' label={t('myCompanies.note')}>
                  <TextArea rows={4} placeholder='maxLength is 300' maxLength={300} disabled={canUserEdit(true)} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={22} push={1}>
                <Form.Item name='supervisor_note' label={t('myCompanies.supervisor_note')}>
                  <TextArea rows={4} placeholder='maxLength is 300' maxLength={300} disabled={canUserEdit()} />
                </Form.Item>
              </Col>
            </Row>
            <CompanyEditActionButtons>
              <Button onClick={() => navigate('/companies')}>{t('global.cancel')}</Button>
              <Button type='primary' htmlType='submit' loading={saving}>
                {t('global.save')}
              </Button>
            </CompanyEditActionButtons>
          </Form>
        ) : (
          <Empty />
        )}
      </Loader>
    </>
  );
};
